import {Page, SubPage, Vendor} from '@entities/left-panel/left-panel.interface';
import {LoadingStatus, status} from 'amc-common-components';
import {createReducer, on} from '@ngrx/store';
import {LeftPanelActions} from '@store/left-panel/actions';
import {assoc, pipe} from 'ramda';

/**
 * Auxiliary store state interface declaration.
 */
export interface LeftPanelState {
	/** {Page[]} pages */
	pages: Page[];
	/** {LoadingStatus} pagesLoadingStatus */
	pagesLoadingStatus: LoadingStatus;
	/** {Page} activePage */
	activePage: Page;
	/** {SubPage} activeSubPage */
	activeSubPage: SubPage;
	/** {Vendor} activeVendor */
	activeVendor: Vendor;
	/** {boolean} hideLeftPanel */
	hideLeftPanel: boolean;
}

/** Auxiliary 'initialLeftPanelState' variable.' */
export const initialLeftPanelState: LeftPanelState = {
	pages: [],
	pagesLoadingStatus: status.default,
	activePage: null,
	activeSubPage: null,
	activeVendor: null,
	hideLeftPanel: true,
};

/** Auxiliary 'leftPanelReducer' variable.' */
export const leftPanelReducer = createReducer(
	initialLeftPanelState,
	on(LeftPanelActions.load.requested, (state) => assoc('pagesLoadingStatus', status.loading, state)),
	on(LeftPanelActions.load.succeeded, (state, {pages}) =>
		pipe(assoc('pagesLoadingStatus', status.loaded), assoc('pages', pages))(state)
	),
	on(LeftPanelActions.load.failed, (state, {error}) => assoc('pagesLoadingStatus', status.error(error), state)),
	on(LeftPanelActions.selection, (state, {page, subPage, vendor}) =>
		pipe(
			assoc('activePage', page),
			assoc('activeSubPage', subPage || null),
			assoc('activeVendor', vendor || null)
		)(state)
	),
	on(LeftPanelActions.toggle, (state) => assoc('hideLeftPanel', !state.hideLeftPanel, state))
);
